export const NoResultsLetter = ({
  width = 16,
  height = 16,
  viewBox = '0 0 16 16',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
      fill="none"
    >
      <path
        d="M4 10.666L8 2.66602L12 10.666M5.33333 7.99935H10.6667M10.6667 13.3327L12 14.666L14.6667 11.9993"
        stroke="#0E0E12"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}
